import { render, staticRenderFns } from "./realTimeVehicle.vue?vue&type=template&id=6edf0e1c&scoped=true&"
import script from "./realTimeVehicle.vue?vue&type=script&lang=js&"
export * from "./realTimeVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf0e1c",
  null
  
)

export default component.exports